import { FormControlLabel, Tabs, TextField, Tab, Box, MenuItem, Typography, FormControl, InputLabel, Select, Grid, Badge } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext"
import { MediaQuerys } from "../../../../styles/GlobalStyle";
import { LoopRounded } from "@mui/icons-material";
import { CustomFormLabel } from "../../../../pages/styles";

const { tablet, desktop } = MediaQuerys;


export const Label = styled(CustomFormLabel)(({nextline, istitle, theme}) => {
    const { colors } = useColors();
    return {
        paddingRight:'5px',
        display: nextline ? 'block' : 'inherit',
        paddingLeft: istitle ? 10 : 0,
        textTransform: istitle ? 'uppercase' : 'none',
        fontSize: '14px',
        lineHeight: 1.1,
		marginBottom: 3,
        [theme.breakpoints.down('md')]: {
          fontSize: '12px'
        },
    }
})

export const CustomTabs = styled(Tabs)(({ theme }) => {
    return {
		minHeight: '38px !important',
        '.MuiButtonBase-root': {
            fontSize: '14px',
            fontFamily: 'Montserrat, sans-serif',
            textTransform: 'inherit',
			padding: '2px 10px',
			minHeight: '18px !important',
			[theme.breakpoints.down('md')]: {
				fontSize: '12px'
			}
        },
		'& .MuiBadge-badge': {
			top: '11px',
		}
    }
});

export const CustomBadge = styled(Badge)(({selected}) => {
    const { colors } = useColors();
    return {
      '& .MuiBadge-badge': {
        backgroundColor: selected ? '#1b7748 !important' : '#b7b7b7',
        color: colors.white,
        fontWeight: selected ? 'bold' : 'normal',
      }
    }
});

export const FormLabel = styled(FormControlLabel)(() => ({
    '.MuiTypography-root': {
        fontWeight: 'bold',
        fontSize: '1.2rem'
    }
}));

export const StateGridContainer = styled(Grid)(() => ({
  backgroundColor: '#f1f4f7',
  padding: '10px',
  borderRadius: '10px',
  alignContent: 'center',
  alignItems: 'stretch',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'row',
}));

export const StateGridItem = styled(Grid)(() => {
  const { colors } = useColors();
  return {
    background: '#ffffff',
    padding: '10px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& section div': {
      fontWeight: 'bold',
      color: colors.buttonActionColor
    }
  }
});

export const IconContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
}));

export const IconLoop = styled(LoopRounded)(() => {
    const { colors } = useColors();
    return {
        background: '#ffffff',
        padding: 10,
        borderRadius: '50%',
        fontSize: 50,
        color: colors.grayFont,
        border: '1px solid #e7e7e8',
    }
});

export const Input = styled(TextField)(() => {
    const { colors } = useColors();
    return {
        width: '100%',
        '.MuiInputBase-root': {
            background: colors.white,
            borderRadius: 6,
            fontSize: 13,
            padding: 0
        }
    }
})

export const LineTop = styled('div')(() => {
    const { colors } = useColors();
    return {
        paddingBottom: 10,
        borderTop: `1px solid ${colors.gray}`
    }
})

export const LineBottom = styled('div')(() => {
    const { colors } = useColors();
    return {
        paddingTop: 10,
        borderBottom: `1px solid ${colors.gray}`
    }
})

export const CustomTab = styled(Tab)(({selected, theme}) => {
    return {
        marginRight: '5px',
		    fontSize: '14px',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px !important'
        },
        color: selected ? '#1b7748 !important' : 'inherit',
        fontWeight: selected ? 'bold' : 'normal',
    }
})

export const ContainerTop = styled('div')(() => {
    return {
        width: '100%',
        display: 'flex',
        padding: '16px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    }
})

export const ContainerGroup = styled('div')(() => {
    return {
        display: 'flex',
        width: '50%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '0.20rem'
    }
})

export const ContainerMid = styled('div')(() => {
    return {
        width: '100%',
        padding: '0px 16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    }
})

export const ContainerContentMid = styled('div')(({ isMiddle }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        width: isMiddle ? '20%' : '40%',
        alignItems: 'center',
        justifyContent: 'center'
    }
})

export const BoxContainer = styled(Box)(({theme}) => {
    return {
        padding: '1rem',
        maxWidth: '100%',
        overflowY: 'auto',
    }
})

export const CustomTypography = styled(Typography)(() => {
    return {
          [desktop]: {
            fontSize: '0.85rem'
        }
    }
})

export const CustomFormControl = styled(FormControl)(() => {
    return {
      width: "100%",
      [desktop]: {
        // width: "250px",
        "& .MuiFormLabel-root": {
          fontSize: "0.75rem",
        },
      },
      // [tablet]: {
      //   width: "100px",
      //   height: 20,
      // },
      // [mobile]: {
      //   width: "80px",
      //   height: 20,
      // },
    };
});

export const CustomInputLabel = styled(InputLabel)(() => {
    return {
      color: 'black',
      fontSize: "1em",
      position: "absolute",
      top: "50%",
      left: "10%",
      transform: "translate(-50%, -50%)",
      [tablet]: {
        fontSize: "0.75rem",
      }
    };
});

export const CustomSelect = styled(Select)(() => {
    return {
      width: "100%",
      height: "40px",
      [desktop]: {
        // width: "250px",
        height: 30,
      },
      // [tablet]: {
      //   width: "100px",
      //   height: 20,
      // },
      // [mobile]: {
      //   width: "80px",
      //   height: 20,
      // },
    };
});

export const CustomMenuItem = styled(MenuItem)(() => {
    return {
      [desktop]: {
        "& .MuiTypography-root": {
          fontSize: "0.75rem",
        },
      },
    };
  });